const swiperIronDamesStaffCards = {
    swiperInstance: null,
    init: () => {
        import('swiper/bundle').then(({Swiper}) => {
            let domEls = document.querySelectorAll('.js-swiper-iron-dames-staff-cards');
            if (domEls) {
                const params = getSwiperParams();
                domEls.forEach(el => {
                    swiperIronDamesStaffCards.swiperInstance = new Swiper(el, params);
                })
            }
        })
    }
};

const getSwiperParams = () => {

    return {
        watchOverflow: true,
        centeredSlides: false,
        spaceBetween: 24,
        slidesPerView: 1,
        slideToClickedSlide: true,
        resizeObserver: true,
        a11y: true,
        mousewheel: {
            forceToAxis: true
        },
        grabCursor: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // pagination: {
        //     el: '.swiper-pagination',
        //     clickable: true,
        //     type: 'progressbar',
        // },
        breakpoints: {
            576: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 3
            }
        }
    }
}

export default swiperIronDamesStaffCards;